import Blockly from 'blockly/browser'
import { defineStmtBlock, defineBlock } from '../Util'

defineBlock(
  'sirenia_api_app_location',
  {
    message0: 'app location',
    args0: [],
    tooltip: 'Gets the current address of the web application',
    output: 'String',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#location'
  },
  function(block) {
    return [`App.location()`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'sirenia_api_app_navigate',
  {
    message0: 'navigate app to %1',
    args0: [
      {
        type: 'input_value',
        name: 'URL',
        check: 'String'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Navigate web app to a url',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#navigate'
  },
  function(block) {
    var url = Blockly.JavaScript.valueToCode(block, 'URL', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return `App.navigate(${url});\n`
  }
)

defineBlock(
  'sirenia_api_app_session',
  {
    message0: 'app session',
    args0: [],
    tooltip: 'Gets the session object',
    output: null,
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#session-write'
  },
  function(block) {
    return [`App.session()`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'sirenia_api_app_quit',
  {
    message0: 'close app',
    args0: [],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Closes the attached application',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#quit'
  },
  function(block) {
    return `App.quit();\n`
  }
)
